import React, { PureComponent } from 'react'
import { t } from '@lingui/macro'
import classNames from 'classnames'

import './ImageLoader.less'

export interface IImageLoaderProps {
  src: string
  srcSet?: string | null
  preloaderWrapper?: React.ReactElement<any>
  alt?: string
  title?: string
}

export interface IImageLoaderState {
  loaded: boolean
  error: boolean
}

export default class ImageLoader extends PureComponent<
  IImageLoaderProps,
  IImageLoaderState
> {
  state = {
    loaded: false,
    error: false
  }

  render() {
    const { loaded, error } = this.state
    if (error) {
      const errorMessage = t`Image unavailable`
      return this.props.preloaderWrapper
        ? React.cloneElement(this.props.preloaderWrapper, {}, errorMessage)
        : errorMessage
    }

    const _spinner = <div className="spinner" />
    const spinner = this.props.preloaderWrapper
      ? React.cloneElement(this.props.preloaderWrapper, {}, _spinner)
      : _spinner

    return (
      <>
        {!loaded && spinner}
        <img
          onLoad={() => {
            this.setState({ loaded: true })
          }}
          onError={() => {
            this.setState({ error: true })
          }}
          src={this.props.src}
          srcSet={this.props.srcSet || undefined}
          alt={this.props.alt}
          title={this.props.title}
          className={classNames('Image', { 'is-loading': !loaded || error })}
        />
      </>
    )
  }
}
